import { render } from "./menu-management.vue?vue&type=template&id=91712794"
import script from "./menu-management.vue?vue&type=script&lang=js"
export * from "./menu-management.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__